<template>
  <thead data-sb-regression="sb-table-thead">
    <tr
      class="sb-table-header"
      scope="row"
    >
      <template v-if="$slots.default">
        <SbTableHead
          v-if="isAllMultiselectable"
          class="sb-table-head__select"
        >
          <SbCheckbox
            v-model:checked="isSelected"
            class="sb-table__select"
            @change="handleSelectAll"
          />
        </SbTableHead>
        <SbTableHead
          v-if="isSingleSelectable || isMultiselectable"
          class="sb-table-head__select"
        >
          <span />
        </SbTableHead>

        <!--
          @slot slot to show table head contents
        -->
        <slot />
      </template>
      <template v-else>
        <SbTableHead
          v-if="isAllMultiselectable"
          class="sb-table-head__select"
        >
          <SbCheckbox
            v-model:checked="isSelected"
            class="sb-table__select"
            @change="handleSelectAll"
          />
        </SbTableHead>
        <SbTableHead
          v-if="isSingleSelectable || isMultiselectable"
          class="sb-table-head__select"
        >
          <span />
        </SbTableHead>

        <template
          v-for="(item, index) in items"
          :key="index"
        >
          <SbTableHead
            :item="item"
          />
        </template>
      </template>
    </tr>
  </thead>
</template>
<script>
import _differenceWith from 'lodash/differenceWith';
import _isEqual from 'lodash/isEqual';

import SbCheckbox from '@src/components/Checkbox/SbCheckbox.vue';
import SbTableHead from '@src/components/Table/components/SbTableHead.vue';

import SelectableMixin from '@src/components/Table/utils/selectableMixin';

export default {
  name: 'SbTableThead',
  components: {
    SbTableHead,
    SbCheckbox,
  },
  mixins: [SelectableMixin],
  inject: ['sbTable', 'sbSelectableTable'],
  computed: {
    items() {
      return this.sbTable.definitions;
    },
    isSelected() {
      if (this.sbSelectableTable.selectableRows.length <= 0) return false;
      return _differenceWith(
        this.sbSelectableTable.selectableRows,
        this.sbSelectableTable.selectedRows,
        _isEqual,
      ).length <= 0;
    },
  },
  methods: {
    handleSelectAll(n) {
      if (n?.target?.checked) this.sbSelectableTable.selectedRows = this.sbSelectableTable.selectableRows.slice();
      else this.sbSelectableTable.selectedRows = [];
    },
  },
};
</script>
<style lang="scss">
@import '@src/components/Table/style/sb-table-thead.scss';
</style>
